import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { JsonViewer } from '@dataxpdtn/mui-json-viewer';
import { useEffect, useState } from 'react';
import { getItemMetadata } from '../../../../../data/Wideawake/wideawakeDataFns';
/** this could be made to support and array of filters which would be ANDed in the current setup */
export const ItemMetadata = ({}) => {
    const getItemMetadataX = async () => {
        const res = await getItemMetadata();
        if (res.data) {
            const metadata = res.data.itemMetadata;
            setItemMetadata(metadata);
        }
        else
            console.log('err in customers', res.err?.message);
    };
    const [itemMetaData, setItemMetadata] = useState({});
    useEffect(() => {
        getItemMetadataX();
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Stack, {}), _jsx(Stack, { direction: 'row', justifyContent: 'left', alignItems: 'flex-start', spacing: 2, children: _jsx("div", { style: { fontSize: 24 }, children: _jsx(JsonViewer, { value: itemMetaData, displayDataTypes: false }, 'summary') }) })] }));
};
